/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-05-08 14:46:50
 * @LastEditors: changfeng
 * @LastEditTime: 2024-06-21 11:12:04
 */

export default {
	ar: "阿拉伯语",
	as: "阿萨姆语",
	bgc: "哈里亚纳语",
	bh: "比哈尔语",
	bn: "孟加拉语",
	cs: "捷克语",
	de: "德国语",
	el: "希腊语",
	en: "英语语",
	es: "西班牙语",
	fi: "芬兰语",
	fr: "法语",
	gu: "古吉拉特语",
	he: "希伯来语",
	hi: "北印度语",
	hu: "匈牙利语",
	id: "印度尼西亚语",
	it: "意大利语",
	ja: "日本语",
	km: "高棉语 ",
	kn: "坎纳达语",
	ko: "韩国语",
	ml: "马拉雅兰语",
	mr: "马拉地语",
	ms: "马来语",
	nl: "荷兰语",
	or: "奥里雅语",
	pa: "旁遮普语",
	pl: "波兰语",
	pt: "葡萄牙语",
	raj: "拉贾斯坦语",
	ro: "罗马尼亚语",
	ru: "俄罗斯语",
	sv: "瑞典语",
	ta: "泰米尔语",
	te: "泰卢固语",
	th: "泰国语",
	tr: "土耳其语",
	uk: "乌克兰语",
	vi: "越南语",
	"zh-Hant": "繁体中文"
};
